// ProgressRail.tsx — clickable step indicator. Port of NP5Progress from
// docs/design/design_handoff_add_new_product/newproduct-v4-5.jsx. States:
// done = green check, active = brand dot w/ glow, open = dashed circle.
import React from "react";
import { NPIcon } from "./atoms";
import type { StepId } from "./state";

export function ProgressRail({
    steps,
    onStepClick
}: {
    steps: { id: StepId; label: string; state: "done" | "active" | "open" }[];
    onStepClick: (id: StepId) => void;
}) {
    const dotColor = { done: "var(--np-success)", active: "var(--np-brand)", open: "var(--fg4)" } as const;
    return (
        <div
            style={{
                display: "flex",
                alignItems: "flex-start",
                padding: "14px 28px 10px",
                background: "var(--bg-paper)",
                borderBottom: "1px solid var(--divider)",
                flex: "0 0 auto"
            }}
        >
            {steps.map((s, i) => (
                <React.Fragment key={s.id}>
                    {i > 0 && (
                        <span
                            style={{
                                flex: 1,
                                height: 2,
                                borderRadius: 2,
                                background: steps[i - 1].state === "done" ? "#a7f3d0" : "var(--divider)",
                                margin: "11px 8px 0",
                                transition: "background .3s ease"
                            }}
                        />
                    )}
                    <div
                        onClick={() => onStepClick(s.id)}
                        style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, cursor: "pointer", flex: "0 0 auto" }}
                    >
                        <span
                            style={{
                                width: 24,
                                height: 24,
                                borderRadius: 12,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: s.state === "open" ? "var(--bg-paper)" : dotColor[s.state],
                                border: s.state === "open" ? "1.5px dashed var(--divider)" : "none",
                                boxShadow: s.state === "active" ? "0 3px 10px rgba(39,51,194,0.35)" : "none"
                            }}
                        >
                            {s.state === "done" ? (
                                <NPIcon name="check" size={11} sw={3} color="#fff" />
                            ) : (
                                <span
                                    style={{
                                        width: 7,
                                        height: 7,
                                        borderRadius: 4,
                                        background: s.state === "active" ? "#fff" : "var(--fg4)",
                                        opacity: s.state === "open" ? 0.55 : 1
                                    }}
                                />
                            )}
                        </span>
                        <span
                            style={{
                                fontSize: 10.5,
                                fontWeight: s.state === "active" ? 700 : 600,
                                color: s.state === "active" ? "var(--np-brand)" : s.state === "done" ? "var(--fg2)" : "var(--fg4)",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {s.label}
                        </span>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
}
